import React, { useEffect, useRef, useState } from "react";
import { Button, Menu, MenuItem } from "@blueprintjs/core";
import { useNavigate, useLocation } from "react-router-dom";
import { useProjects } from "../auth/ProjectContext";
import { useOrg } from "../auth/OrgContext";

export default function ProjectSwitcher() {
  const { currentOrg, setCurrentOrg } = useOrg();
  const { projects, currentProject, setCurrentProject } = useProjects();
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const closeOnClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", closeOnClickOutside);
    return () => document.removeEventListener("mousedown", closeOnClickOutside);
  }, [setOpen]);

  if (!currentOrg) return null;

  const orgProjects = projects.filter((p) => p.orgId === currentOrg.id);

  return (
    <div ref={dropdownRef} style={{ position: "relative", display: "inline-block" }}>
      <Button
        minimal
        icon="briefcase"
        text={currentProject?.name || "Select project"}
        disabled={orgProjects.length === 0}
        onClick={() => setOpen(!open)}
      />
      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            right: 0,
            zIndex: 9999,
            background: "white",
            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
            borderRadius: 4,
            overflow: "hidden",
          }}
        >
          <Menu>
            {orgProjects.map((p) => (
              <MenuItem
                key={p.id}
                text={p.name}
                onClick={() => {
                  if (!currentOrg || currentOrg.id !== p.orgId) {
                    setCurrentOrg({ id: p.orgId, name: p.orgName });
                  }
                  setCurrentProject(p);
                  if (!location.pathname.startsWith("/projects")) {
                    navigate('/projects/overview');
                  }
                  setOpen(false);
                }}
              />
            ))}
          </Menu>
        </div>
      )}
    </div>
  );
}
